import { keyframes, styled } from "styled-components";
import { mobileBreakpoint } from "../../Configs/Config";

interface CircleProps {
    $strokeDashOffsetEnd: number;
    $animationTime: number;
    $circleLineWidth: number;
}


const CircleKeyframes = (props:number) => keyframes`
    0% {
        stroke-dashoffset: 400;
        }
    100% {
        stroke-dashoffset: ${props};
    }
`;

export const ProgressCircle = styled.circle<CircleProps>`
    fill: none;
    stroke-width: ${(props) => props.$circleLineWidth}px;
    stroke-dasharray: 400;
    stroke-dashoffset: ${(props) => props.$strokeDashOffsetEnd};
    animation: ${props=>CircleKeyframes(props.$strokeDashOffsetEnd)} ${props=>props.$animationTime}s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
`;

export const CircleContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    overflow: hidden;
    @media screen and (max-width: ${props => props.theme.breakpoint}px){
        justify-content: center;
    }
    @media screen and (max-width: 700px){
        justify-content: center;
    }
`;

interface PercentDisplayProps {
    $topOffset: number;
    $leftOffset: number;
    $fontColor: string;
}

export const CirclePercentDisplay = styled.div<PercentDisplayProps>`
    position: relative;
    width: 20px;
    top: -${(props) => props.$topOffset}px;
    left: ${(props) => props.$leftOffset}px;
    font-weight: 600;
    @media screen and (max-width: ${mobileBreakpoint}px){
        width: 10px;
    }
`;

interface CircleLabelProps {
    $fontSize: number;
    $fontWeight: number;
    $fontColor: string;
    $paddLeft: number;
    $mobilePadRight: number;
    $mobilePadLeft: number;
}

export const CircleLabel = styled.div<CircleLabelProps>`
    text-transform: uppercase;
    font-size: ${props=>props.$fontSize}px;
    font-weight: ${props=>props.$fontWeight};
    padding-left: ${props=>props.$paddLeft}px;
    @media screen and (max-width: ${mobileBreakpoint}px){
        padding-left: ${props=>props.$mobilePadLeft}px;
        padding-right: ${props=>props.$mobilePadRight}px;
    }
`;
